import insights from '../Static/Insights/insights.json';
import { getPfmType } from './storageUtils';

export interface Insight {
  id: string;
  type: string;
  icon: string;
  color: string;
  title: string;
  description: string;
  profile: string;
}

export function getInsights(): Insight[] {
  const userProfile = getPfmType();
  return insights.filter((insight) => insight.profile === userProfile);
}

export function getAllInsights(): Insight[] {
  return insights;
}
